import type { MedicineArticle } from '~/models'
import { PullService } from './servicePull'
import { getDoc } from 'firebase/firestore'

export class MedicineArticlePullService extends PullService<
  MedicineArticle,
  MedicineArticle[]
> {
  private doc

  constructor() {
    super()
    const { doc } = useFirebase()
    this.doc = doc
  }

  public async getMedicineArticleById(
    medicineArticleId: string,
  ): Promise<MedicineArticle> {
    const snapshot = await getDoc(
      this.doc<MedicineArticle>('MedicineArticles', medicineArticleId),
    )

    if (!snapshot.exists()) {
      throw new Error(
        `MedicineArticle with ID ${medicineArticleId} does not exist`,
      )
    }

    return snapshot.data() as MedicineArticle
  }
}
